import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const load = () => api.get("/categories").then(({ data }) => setCats(data));
  useEffect(() => { load(); }, []);

  const addSub = async (catId) => {
    const name = prompt("Subcategory name:");
    if (!name) return;
    await api.post("/subcategories", { category_id: catId, name }); load();
  };
  const del = async (id) => { if (window.confirm("Delete this category?")) { await api.delete(`/categories/${id}`); toast.success("Deleted"); load(); } };

  return (
    <div data-testid="admin-categories">
      <PageHeader title="Categories" subtitle="Manage course categories & subcategories" action={<NewCategory onDone={load} />} />
      {cats.length === 0 ? <EmptyState icon={Plus} title="No categories" /> : (
        <div className="grid md:grid-cols-2 gap-4">
          {cats.map((c) => (
            <div key={c.id} className="bg-white border border-border rounded-lg p-5" data-testid={`cat-${c.id}`}>
              <div className="flex items-center justify-between">
                <h3 className="font-heading font-bold text-navy">{c.name}</h3>
                <button onClick={() => del(c.id)} className="text-crimson"><Trash2 size={16} /></button>
              </div>
              <div className="flex flex-wrap gap-2 mt-3">
                {c.subcategories?.map((s) => <span key={s.id} className="text-xs bg-muted px-2 py-1 rounded">{s.name}</span>)}
                <button onClick={() => addSub(c.id)} className="text-xs text-amber font-semibold" data-testid={`add-sub-${c.id}`}>+ Add subcategory</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function NewCategory({ onDone }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const create = async () => { if (!name) return; await api.post("/categories", { name }); toast.success("Category added"); setOpen(false); setName(""); onDone(); };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button className="viriks-navy text-white" data-testid="new-category-btn"><Plus size={16} className="mr-1" /> Add Category</Button></DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Add Category</DialogTitle></DialogHeader>
        <div><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="cat-name" /></div>
        <DialogFooter><Button className="viriks-navy text-white" onClick={create} data-testid="cat-submit">Add</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
